export enum AppAction {
    SET_LOADING = 'IP/APP/SET_LOADING',
    SET_ERROR = 'IP/APP/SET_ERROR',
    SET_PRODUCT_SUGGESTIONS = 'IP/APP/SET_PRODUCT_SUGGESTIONS',
    SET_ACTIVE_VIEW = 'IP/APP/SET_ACTIVE_VIEW',
    SET_COOKIE = 'IP/APP/SET_COOKIE',
    SET_OVERLAY_LOADED = 'IP/APP/SET_OVERLAY_LOADED',
    INIT_OVERLAY = 'IP/APP/INIT_OVERLAY',
    INIT_APP = 'IP/APP/INIT_APP',
    TOGGLE_OVERLAY = 'IP/APP/TOGGLE_OVERLAY',
    TRACK_LEAD_MANAGEMENT = 'IP/APP/TRACK_LEAD_MANAGEMENT',
    SET_TOKEN_STATE = 'IP/APP/SET_TOKEN_STATE',
};
